export const SIMULATION_OTP_CODE = "333000";

export const PAYMENT_FLOW_TYPES_AVAILABLE_FOR_SIMULATION = [
  "FORM",
  "QR_CODE",
  "DEBIT_CARD",
  "TABS",
  "STEPS"
];
